<template>
  <div class="top-nav mx-auto min-h-screen-footer">
    <div class="row mt44 mx-0 px-8">
      <Sidebar
        :freebies="true"
        @free="getCoursesFree"
        @seeall="sellAllCourse"
        :categories="categories"
        @categorySelect="getCoursesCat"
      />

      <div class="col pt-2">
        <h1 class="font text-left stext col pl-35">
          {{ title_cat }}
        </h1>

        <div class="line d-lg-none"></div>
        <div v-if="spinner || loading" class="row mt-4 px-20 mx-0 mt-60 h-full">
          <sync-loader
            :color="color"
            v-if="spinner || loading"
            style="margin-left: 45%; padding-top: 10%; padding-bottom: 5%"
          ></sync-loader>
        </div>

        <div
          v-if="!spinner && !loading"
          class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 pb-60px gap-y-40 mt-40px justify-items-center"
        >
          <CourseCard
            :explore_card="true"
            v-for="(item, index) in course"
            :key="index"
            :course="item"
            :image="item.resources_image.data"
            :name="item.courses.name"
            :description="item.courses.description"
            :price="item.data.price"
            :users_in_course="item.users_in_course"
            :destacate="item.destacate"
            :free="item.data.free"
          />

          <div class="col-12 mt-4 lg:col-span-2 xl:col-span-3" align="center" v-if="course.length == 0">
            <img src="/image/resource/empty.png" />

            <h1 class="empty-text">No existen cursos disponibles</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SyncLoader from "vue-spinner/src/PulseLoader.vue";
import Sidebar from "../../../v2/src/components/Sidebar.vue";
import CourseCard from "../../../v2/src/components/CourseCardExternal.vue";

export default {
  name: "Category",
  components: {
    SyncLoader,
    Sidebar,
    CourseCard,
  },
  data: () => ({
    spinner: false,
    applyFixed: true,
    color: "#9A32D6",
    showAll: false,
  }),
  computed: {
    ...mapGetters({
      categories: "category/allCategories",
      selected_category: "category/getCategorySelected",
      course: "course/all_courses",
      loading: "course/loading",
      key: "course/getKey",
      isLoggedIn: "auth/isLoggedIn",
    }),
    searchValue() {
      return this.$route.query.q;
    },
    title_cat() {
      if (
        this.$route.query.category == "all" ||
        this.$route.query.category == "search"
      ) {
        return "Cursos";
      } else {
        if (this.selected_category) {
          return `Cursos de ${
            this.selected_category.name != "" ? this.selected_category.name : ""
          }`;
        }

        if (this.key) {
          return `Cursos de ${this.key}`;
        }
      }
      return "";
    },
  },
  watch: {
    searchValue() {
      this.$store.dispatch("course/getCoursesByKey", {
        key_code: this.searchValue,
      });
    },
  },
  mounted() {
    if (this.categories.length == 0) {
      this.getCategories();
    } else {
      if (this.$route.query.q != "" && this.$route.query.category == "search") {
        this.$store.dispatch("course/getCoursesByKey", {
          key_code: this.$route.query.q,
        });
      }
    }
    window.addEventListener("scroll", this.scroll);
  },
  methods: {
    setRoute(name) {
      this.$router.push({ name: name });
    },
    getCoursesFree: function() {
      this.$router.push({
        name: "Category",
        query: { category: "free" },
      });
      this.spiner = true;
      this.$store
        .dispatch("course/getExternalAllCourses", {
          proyect_id: process.env.VUE_APP_PROYECT_ID,
          free: true,
        })
        .then((response) => {
          this.cours = response;
          this.spiner = false;
        })
    },

    getCoursesCat: function(cat) {
      this.$router.push({
        name: "Category",
        params: {
          slug: cat.name
            .toLowerCase()
            .replace(/ /g, "-")
            .replace(/[^\w-]+/g, ""),
        },
        query: { category: cat.id },
      });
      this.showAll = false;
      this.spinner = true;
      this.nav = false;
      this.$store.commit("category/SET_CAT", cat);
      this.$store
        .dispatch("course/getAllCourses", {
          category_id: cat.id,
          proyect_id: process.env.VUE_APP_PROYECT_ID,
        })
        .then(() => {
          this.spinner = false;
        })
    },
    sellAllCourse(){
      this.$router.push({
        name: "Category",
        query: { category: "all" },
      });
      this.getCourses();
    },
    getCourses: function() {
      this.showAll = true;
      this.spinner = true;

      if (this.$route.query.q != "" && this.$route.query.category == "search") {
        this.$store
          .dispatch("course/getCoursesByKey", {
            key_code: this.$route.query.q,
          })
          .then(() => {
            this.spinner = false;
          });
      } else {
        this.$store
          .dispatch("course/getExternalAllCourses", {
            proyect_id: process.env.VUE_APP_PROYECT_ID,
          })
          .then(() => {
            this.spinner = false;
          });
      }
    },
    getCategories: function() {
      this.spinner = true;
      this.$store.dispatch("category/getCategory").then((data) => {
        let aux = data.filter(
          (element) => element.id == this.$route.query.category
        );
        this.spinner = false;
        if (aux.length != 0) {
          this.getCoursesCat(aux[0]);
        } else {
          if (this.$route.query.category == "free") {
            this.getCoursesFree();
          } else {
            this.getCourses();
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.min-h-screen-footer{
  min-height: calc(100vh - 100px);
}

.titleNav {
  font-family: "Roboto", sans-serif;
  font-size: 18px;
  font-weight: bold;
  color: #848484;
  margin-bottom: 2px;
}

.boxNav {
  padding: 30px 40px;
  border-radius: 0 0 8px 8px;
  box-shadow: 0px 0px 7px 0px rgba(150, 150, 150, 0.5);
  margin-bottom: 40px;
}

.h-full {
  min-height: 100vh;
}

.over-flow {
  overflow-y: overlay;
  max-height: 350px;
}

.empty-text {
  color: #000000;
  font-size: 26px;
  margin-top: 30px;
  font-weight: bold;
  font-family: "Roboto", sans-serif;
}

.icon-svg {
  top: 20px;
  left: 1105px;
  width: 30px;
  height: 20px;
  padding-right: 2px;
  opacity: 1;
}

.over-flow::-webkit-scrollbar {
  width: 5px;
}

.over-flow::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
}

.over-flow::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid #dddd;
}

.top-nav {
  padding-top: 64px;
  max-width: 1440px;
  overflow: hidden;
}

.ml-420 {
  margin-left: 420px;
}

@media (max-width: 990px) {
  .stext {
    font: normal normal 900 20px/18px Roboto !important;
  }

  .mt-60 {
    margin-top: 60px !important;
  }

  .ml-420 {
    margin-left: auto;
  }

  .certi {
    right: 25px;
  }
}

@media (max-width: 320px) {
  .line {
    width: 340px !important;
  }
}

.mt44 {
  margin-top: 44px;
}

.font {
  font: normal normal 900 40px/18px Roboto;
  font-size: 40px;
  color: #000000;
}

.font-filter {
  font: normal normal normal 16px/18px Roboto;
}

.line {
  position: absolute;
  height: 2px;
  background-color: #b6b6b6;
  width: 100vw;
  left: 0px;
  margin-top: 10px;
}

.w295 {
  width: 295px;
  margin-left: 70px;
}

.tile {
  cursor: pointer;
  font: normal normal normal 15px/22px Roboto;
  letter-spacing: 0px;
  color: #848484;
}

.border-bottom {
  border-bottom: 1px solid #b4b4b4 !important;
}

.tile:hover {
  color: #446daf !important;
}

.sticky {
  position: fixed;
}

.top {
  position: sticky;
  top: 100%;
  margin-bottom: 20px;
}

.not:hover {
  color: #848484 !important;
  cursor: normal;
}

.blue-text {
  color: #446daf;
}

.tile2 {
  font: normal normal normal 18px/22px Roboto;
}

.nav-mobile {
  overflow: auto;
  overflow-x: hidden;
  z-index: 999;
  height: 100%;
  top: 0;
  position: fixed;
  background: white;
  min-height: 100vh;
  position: fixed;
}
</style>
